import { CommonModule, Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { InputOtpModule } from 'primeng/inputotp';
import { ButtonComponent } from '../../../@core/components/ui/button/button.component';
import { ToastService } from '../../../@core/services/toast.service';
import { FingerprintService } from '../../services/fingerprintJs.service';
import { ShareContractService } from '../../services/share-contract.service';
import { APPROVER_TYPE } from 'src/app/@core/models/model';

@Component({
  selector: 'app-email-authentication',
  standalone: true,
  imports: [ButtonComponent, CommonModule, InputOtpModule, FormsModule, DividerModule],
  templateUrl: './email-authentication.component.html'
})
export class EmailAuthenticationComponent {
  sendMailLabel: string = 'Send Verification Email';
  user: string = ""
  contract: string = ""
  share: string = ""
  otp: string = ""
  otpVerified: boolean = false
  mailSent: boolean = false
  sendingMail: boolean = false
  constructor(
    private route: ActivatedRoute,
    private shareContractService: ShareContractService,
    private toast: ToastService,
    private fingerprintService: FingerprintService,
    private router: Router,
    private location: Location
  ) {
    this.route.queryParams.subscribe(params => {
      this.user = params['user'];
      this.contract = params['contract'];
      this.share = params['share']
    })
  }

  sendVerificationEmail() {
    this.sendingMail = true
    const data = {
      contract: this.contract,
      user: this.user,
      share: this.share
    }
    this.shareContractService.authSharedContract(data).subscribe((res) => {
      if (res.success) {
        this.toast.success('Verification Email Sent Successfully')
        this.mailSent = true
      }
      this.sendingMail = false
    })
  }

  async getAnonymousId() {
    await this.fingerprintService.loadFingerprint(this.user, this.contract)
    // navigate to the contract
    this.location.back()
  }

  verifyOTP() {
    const data = {
      contract: this.contract,
      user: this.user,
      otp: this.otp,
      share: this.share
    }
    this.shareContractService.verifyOtp(data).subscribe((res) => {
      if (res.success) {
        if (res.data && res.data.user?.type === "INTERNAL") {
          this.toast.success('OTP Verified Successfully. Redirecting to login...')
          this.otpVerified = true
          setTimeout(() => {
            const returnUrl = this.router.serializeUrl(
              this.router.createUrlTree(['/edit-document'], { queryParams: { documentId: this.contract } })
            )
            this.router.navigate(['/login'], { queryParams: { returnUrl } })
          }, 2000)
        }
        else {
          this.toast.success('OTP Verified Successfully')
          this.otpVerified = true
          this.getAnonymousId()
        }
      }
    })
  }
}
